export default "__VITE_ASSET__265c6c9d__"